"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "albaredo-arnaboldi": {
    "2f9db806": [{
      "hkey": "842aa3e6",
      "slug": "campospinoso-albaredo",
      "name": "Campospinoso Albaredo",
      "primary": true,
      "skipSearch": false
    }],
    "albaredo-arnaboldi": [{
      "hkey": "842aa3e6",
      "slug": "campospinoso-albaredo",
      "name": "Campospinoso Albaredo",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;